/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { MESSAGING_TYPES } from 'cio/utils/action-info';
import { MESSAGING_STATES, MESSAGING_STATE_FLY_ICONS } from 'cio/utils/email-states';

interface SendingBehaviorArgs {
  actionAbstract: any;
  isSaving: boolean;
  hasReadOnlyPermission: boolean;
}

export default class SendingBehavior extends Component<SendingBehaviorArgs> {
  @computed('args.actionAbstract.action.type')
  get canSetSendingState() {
    return MESSAGING_TYPES.filter(
      (type) => !['attribute_update_action', 'collection_query_action'].includes(type),
    ).includes(this.args.actionAbstract.action.type);
  }

  @computed(
    'args.actionAbstract.action.{hasNoRequest,hasNoContent,hasNoSubject}',
    'args.actionAbstract.{holdout,sendingState}',
  )
  get messagingStates() {
    let { action } = this.args.actionAbstract;
    let { info } = action;

    let shouldDisable =
      (info.showRequest && action.hasNoRequest) ||
      (info.showNoContent && action.hasNoContent) ||
      (info.showNoSubject && action.hasNoSubject);

    if (this.args.actionAbstract.holdout) {
      shouldDisable = false;
    }

    return MESSAGING_STATES.map(({ label, value }) => {
      let disabled = false;

      if (shouldDisable && value === 'automatic') {
        disabled = true;
      } else if (
        value === 'off' &&
        this.args.actionAbstract.holdout &&
        this.args.actionAbstract.sendingState !== 'off'
      ) {
        disabled = true;
      }

      return { label, value, disabled };
    });
  }

  @computed('args.actionAbstract.{actionType,attributesMappings,sendingState}')
  get showWebhookDraftPauseNotice() {
    let { actionType, attributesMappings, sendingState } = this.args.actionAbstract;
    return actionType === 'webhook_action' && attributesMappings.length > 0 && sendingState === 'draft';
  }

  _messagingStateIcons = MESSAGING_STATE_FLY_ICONS;
}
